<div class="views-container nav-bar" *ngIf="!responsive.isXSmall()">
    <div class="nav-bar-wrap container-width">
        <a
            (click)="selectTemplate(i + 1)"
            *ngFor="let nav of getOpsAlarmChild(); index as i"
            [ngClass]="{ active: nav === selectedLabel }"
        >
            {{ nav }}
        </a>
    </div>
</div>

<div
    class="child-container container-width"
    [ngClass]="responsive.deviceAndOrientation"
    #childContainer
>
    <ng-container
        *ngTemplateOutlet="
            selectedTemplate === undefined && !responsive.isXSmall()
                ? monitoring
                : selectedTemplate
        "
    ></ng-container>
    <ng-template #monitoring>
        <app-ops-alarm-monitoring
            (onBackEmit)="selectTemplate(0)"
        ></app-ops-alarm-monitoring>
    </ng-template>
    <ng-template #history>
        <app-ops-alarm-history
            (onBackEmit)="selectTemplate(0)"
            (onBackToTop)="backToTop()"
        ></app-ops-alarm-history>
    </ng-template>
    <ng-template #operations>
        <app-ops-operations
            (onBackEmit)="selectTemplate(0)"
            (onBackToTop)="backToTop()"
        ></app-ops-operations>
    </ng-template>
    <div
        class="tap-container container-width"
        *ngIf="responsive.isXSmall() && selectedTemplate === undefined"
        [elements]="mainContent"
    >
        <div class="tap-list">
            <div
                class="tap text"
                (click)="selectTemplate(i + 1)"
                *ngFor="let nav of getOpsAlarmChild(); index as i"
            >
                {{ nav }}
            </div>
        </div>
    </div>
</div>
